import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreRoutingModule } from './core-routing.module';
import { CoreWelcomeComponent } from './components/core-welcome/core-welcome.component';
import { SharedModule } from '../shared/shared.module';
import { CoreFallbackComponent } from './components/core-fallback/core-fallback.component';
import { CoreSubcriptionPricingPageComponent } from './components/core-subcription-pricing-page/core-subcription-pricing-page.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreSupportComponent } from './components/core-support/core-support.component';
import { CoreDownloadQrComponent } from './components/core-download-qr/core-download-qr.component';
import { ColorPickerModule } from '@iplab/ngx-color-picker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreContactComponent } from './components/core-contact/core-contact.component';
import { CoreTermsAndConditionsComponent } from './components/core-terms-and-conditions/core-terms-and-conditions.component';
import { CorePrivacyPoliciesComponent } from './components/core-privacy-policies/core-privacy-policies.component';
import { CoreApiDocumentationComponent } from './components/core-api-documentation/core-api-documentation.component';
import { CorePopUpLandingPageComponent } from './components/core-pop-up-landing-page/core-pop-up-landing-page.component';
import { CoreFaqsLandingPageComponent } from './components/core-faqs-landing-page/core-faqs-landing-page.component';
import { CoreRedemptionLandingPageComponent } from './components/core-redemption-landing-page/core-redemption-landing-page.component';
import { AuthModule } from '../auth/auth.module';
import { CoreReferralLandingPageComponent } from './components/core-referral-landing-page/core-referral-landing-page.component';
import { CorePromotionalDiscountsComponent } from './components/core-promotional-discounts/core-promotional-discounts.component';
import { CoreProductsWrapperComponent } from './components/core-products/core-products-wrapper/core-products-wrapper.component';
import { CoreProductsMenuComponent } from './components/core-products/core-products-menu/core-products-menu.component';
import { CoreCartComponent } from './components/core-cart/core-cart.component';
import { CoreProductUseCasesComponent } from './components/core-products/core-products-wrapper/core-product-use-cases-wrapper/core-product-use-cases/core-product-use-cases.component';
import { CoreProductUseCasesWrapperComponent } from './components/core-products/core-products-wrapper/core-product-use-cases-wrapper/core-product-use-cases-wrapper.component';


@NgModule({
  declarations: [
    CoreWelcomeComponent,
    CoreFallbackComponent,
    CoreSubcriptionPricingPageComponent,
    CoreSupportComponent,
    CoreDownloadQrComponent,
    CoreContactComponent,
    CoreTermsAndConditionsComponent,
    CorePrivacyPoliciesComponent,
    CoreApiDocumentationComponent,
    CorePopUpLandingPageComponent,
    CoreFaqsLandingPageComponent,
    CoreRedemptionLandingPageComponent,
    CoreReferralLandingPageComponent,
    CorePromotionalDiscountsComponent,
    CoreProductsWrapperComponent,
    CoreProductsMenuComponent,
    CoreCartComponent,
    CoreProductUseCasesComponent,
    CoreProductUseCasesWrapperComponent,
  ],
  imports: [
    AuthModule,
    FormsModule,
    ColorPickerModule,
    ReactiveFormsModule,
    SharedModule,
    CommonModule,
    CoreRoutingModule,
    NgSelectModule,
  ]
})
export class CoreModule { }
